const customer_user_items = [
    {
        icon: 'mdi-truck',
        title: 'container-box.customer-list',
        to: '/tables/customer-container-box-list',
    },
];
export {
    customer_user_items
};